import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TopNav from "@/components/TopNav";
import MobileTabBar from "@/components/MobileTabBar";
import HomePage from "@/pages/HomePage";
import ProgrammePage from "@/pages/ProgrammePage";
import BookPage from "@/pages/BookPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import InvitePage from "@/pages/InvitePage";
import StoriesPage from "@/pages/StoriesPage";
import HowToPage from "@/pages/HowToPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <TopNav />
        <main className="pb-24 md:pb-0">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/programme" element={<ProgrammePage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/invite" element={<InvitePage />} />
            <Route path="/stories" element={<StoriesPage />} />
            <Route path="/howto" element={<HowToPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <MobileTabBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
